import { AsyncPipe } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Apollo } from 'apollo-angular';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GetAssociateSearch } from '../gql-associate-search';
import { AssociateSearchResult } from '../associate-search-result-models';
import { AssociateSearchArgs, AssociateSearchComponent } from './associate-search/associate-search.component';

@Component({
    selector: 'u-dc-associate-search-modal',
    templateUrl: './associate-search-modal.component.html',
    standalone: true,
    imports: [AsyncPipe, AssociateSearchComponent],
})
export class AssociateSearchModalComponent {
    errorMessage: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchResult$ = new Subject<any>();

    constructor(
        @Optional() private readonly activeModal: NgbActiveModal,
        private readonly captchaService: ReCaptchaV3Service,
        private readonly apollo: Apollo,
    ) {}

    onBackClicked(): void {
        this.searchResult$.next(null);
    }

    onCloseClicked(): void {
        this.activeModal?.close();
    }

    onAssociateSearchClicked(associateSearchArgs: AssociateSearchArgs): void {
        this.searchResult$.next(null);

        this.captchaService
            .execute('associateSearchIndia')
            .pipe(
                switchMap((captcha: string) =>
                    this.apollo.query<AssociateSearchResult>({
                        query: GetAssociateSearch,
                        variables: {
                            customerId: associateSearchArgs.customerId,
                            firstName: associateSearchArgs.firstName,
                            lastName: associateSearchArgs.lastName,
                            captcha,
                        },
                    }),
                ),
            )
            .subscribe((result) => this.searchResult$.next(result));
    }
}
